import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Resets table row selection when user clicks the same menu item (current route).
 * Menu must navigate with state: { menuReclick: true } when same item is clicked.
 */
export const useResetSelectionOnMenuReclick = (rowSelection: {
	onReset?: () => void;
}) => {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (location.state?.menuReclick) {
			rowSelection.onReset?.();
			navigate(location.pathname, { state: {}, replace: true });
		}
	}, [
		location.state?.menuReclick,
		location.pathname,
		navigate,
		rowSelection.onReset,
	]);
};
